const isCSSVar = (name) => name.startsWith("--");
export {
  isCSSVar
};
